import { render, staticRenderFns } from "./claimForm.vue?vue&type=template&id=7372fd2a&"
import script from "./claimForm.vue?vue&type=script&lang=js&"
export * from "./claimForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports